<i18n src="@/locales/modules/NoteTranslate.json"></i18n>

<template>
	<draggable v-model="localValue" v-bind="$attrs" @end="data => $emit('onSort', data)">
		<transition-group
			tag="div"
			name="slide-fade"
			class="list-note"
		>
			<note-item
				v-for="data in localValue"
				:key="data.id"
				:value="data"
				:isActive="data.id === activeId"
				:noTitleText="$t('NoTitle')"
				@onRemove="noteData => $emit('onRemove', noteData)"
				@click="noteData => $emit('onClickItem', noteData)"
			/>
		</transition-group>
	</draggable>
</template>

<script>
import _ from "lodash";
import NoteItem from "./NoteItem";
import Draggable from "vuedraggable";

export default {
	name: "ListNoteDraggable",
	components: { NoteItem, Draggable },
	props: {
		value: {
			type: Array,
			validator: prop => {
				if (!_.isEmpty(prop)) {
					return !_.some(prop, data => {
						return !(
							_.has(data, "id") &&
							_.has(data, "date") &&
							_.has(data, "color") &&
							_.has(data, "title") &&
							_.has(data, "excerpt")
						);
					});
				}
				return true;
			}
		},
		activeId: {
			type: [String, Number]
		}
	},
	emits: {
		onSort: {},
		onRemove: {},
		onClickItem: {},
	},
	data() {
		return {
			localValue: []
		}
	},
	watch: {
		value() {
			if(JSON.stringify(this.value) !== JSON.stringify(this.localValue)) {
				this.localValue = [...this.value];
			}
		}
	}
};
</script>
